module.exports = "/lucky-balls/img/infobox/info_Box_023.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_023.png
// module id = 1088
// module chunks = 0